import { REDIRECT_URL } from '../../utils/app/const';

export default function Redirect() {
  window.location.href = REDIRECT_URL;

  return <div></div>;
}
